import { useEffect, useRef } from 'react';
// pass in the forwarded ref to and return a consistent ref object
export const useForwardedRef = (ref) => {
  const innerRef = useRef(null);
  useEffect(() => {
    if (!ref) return;
    if (typeof ref === 'function') {
      ref(innerRef.current);
    } else {
      ref.current = innerRef.current;
    }
  });

  return innerRef;
};
